module.exports = __webpack_public_path__ + "static/media/Products_Circle.81fb3521.svg";